<template></template>
<script>
import store from '@/store';
import { mapState, mapMutations } from 'vuex';

export default {
  name: "webSocket",
  data() {
    return {
      lockReconnect: false,
      websock: null,
    }
  },
  computed: {
    socketInfo: () => {
      return store.state.devOps['WEBSOCKET']
    }
  },
  watch: {
    socketInfo: {
      deep: true,
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal.params) !== JSON.stringify(oldVal.params) && newVal.url) {
          console.log('监听Socket入参变换')
          this.websocketSend()
        }
        // 监听是否要断开webSocket
        if (!newVal.url) this.websock.close();
      }
    },
  },
  created() {
    console.log(this.socketInfo, '初始化')
    this.socketInfo.url && this.initWebSocket();
  },
  destroyed: function () {
    console.log('websocket销毁')
    this.socketInfo.url && this.websock.close();
    this.closeWebSocket()
  },
  methods: {
    ...mapMutations(['openWebSocket', 'sendWebSocket', 'closeWebSocket', 'saveWebSocket']),
    initWebSocket: function () {
      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
      this.websock = new WebSocket(this.socketInfo.url);
      this.websock.onopen = () => {
        console.log("WebSocket连接成功");
        this.websocketSend()
      };
      this.websock.onerror = () => {
        console.log("WebSocket连接发生错误");
        this.reconnect();
      };
      this.websock.onmessage = (e) => {
        console.log("-----接收消息-------", e.data);
        var data = eval("(" + e.data + ")"); //解析对象
        this.saveWebSocket(data); // 储存接收到的信息
      };
      this.websock.onclose = (e) => {
        console.log("connection closed (" + JSON.stringify(e) + ")");
      };
    },
    websocketSend() { // 数据发送
      try {
        console.log('数据发送', this.socketInfo.params)
        this.websock.send(JSON.stringify(this.socketInfo.params));
      } catch (err) {
        console.log("send failed (" + err.code + ")");
      }
    },
    reconnect() {
      var that = this;
      if (that.lockReconnect) return;
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        console.info("尝试重连...");
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
  }
}
</script>